import { useContext, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { AxiosContext } from "services/axios.context";

const useCreateTrackMasterRight = (trackID) => {
  const { client } = useContext(AxiosContext);
  const [error, setError] = useState("");
  const queryClient = useQueryClient();
  return {
    createTrackMasterRight: useMutation(
      (data) =>
        client
          .post(`tracks/${trackID}/master_rights/`, data)
          .then((res) => res.data),
      {
        onSuccess: () => queryClient.invalidateQueries(`track-${trackID}`),
      }
    ),
    error: error,
  };
};

export default useCreateTrackMasterRight;
